<template>
    <PageLayout :has-title="hasTitle" :form-title="formTitle" :has-list-scroll="hasListScroll">
        <template #title v-if="pageTitle"
            ><h4 class="mb-0">{{ pageTitle }}</h4>
        </template>
        <template #content>
            <div class="h-100 d-flex flex-column">
                <!-- CREATE FORM -->
                <section
                    id="ListLayout__Content"
                    class="card px-0 material-card mb-2 animated"
                    :class="showForm ? 'faster fadeInDown' : 'slow fadeOutUp'"
                    v-show="showForm"
                >
                    <section class="card-body mx-lg-5 py-2">
                        <h5 class="text-capitalize">{{ formTitle }}</h5>
                        <slot name="list-form"></slot>
                    </section>
                </section>
                <header class="d-flex flex-row align-items-center mb-1 card p-2 filter-container" v-show="hasHeader">
                    <slot name="list-header"></slot>
                    <slot name="list-header-drop"></slot>

                    <slot name="list-header-new"></slot>
                </header>
                <slot></slot>
            </div>
        </template>
    </PageLayout>
</template>

<style scoped>
#ListLayout__Content {
    z-index: 1;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

import PageLayout from "../PageLayout/PageLayout.vue";

export default defineComponent({
    components: {
        PageLayout
    },

    props: {
        pageTitle: { type: String, default: "" },
        formTitle: { type: String, default: "" },
        showForm: { type: Boolean, default: false },
        hasTitle: { type: Boolean, default: false },
        hasHeader: { type: Boolean, default: true },
        hasListScroll: { type: Boolean, default: true }
    }
});
</script>
